import React, { StrictMode } from "react";
import { hot } from "react-hot-loader/root";
import { Meta } from "@sicredi/react";
import { Routes } from "#/routes";

export const App: React.FC = () => {
  return (
    <>
      <Meta titleTemplate="%s - Sicredi" defaultTitle="Sicredi" />

      <main>
        <StrictMode>
          <Routes />
        </StrictMode>
      </main>
    </>
  );
};

export default hot(App);
